module.exports = __webpack_public_path__ + "img/user.d29c3be5.png";